// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3I1cn","rootSuccess":"CompleteLink_rootSuccess__3eU0C","rootFailure":"CompleteLink_rootFailure__1DEw7","isDisabled":"CompleteLink_isDisabled__2bHyP"};